<template>
  <el-main>
      <!-- <div class="tags-view-container">
        <router-link class="tags-view-item" :to="item.path" :key="item.path" :class="isActive(item)?'active':''" v-for="(item) in visitedViews" @contextmenu.prevent.native="openMenu(item,$event)">
          {{$t(item.tagsName?item.tagsName:item.name)}}
          <span class='el-icon-close' @click.prevent.stop='closeSelectedTag(item)' v-if="item.path != '/index'"></span>
        </router-link>
        <ul class="contextmenu" v-show="visible" :style="{left:left+'px',top:'20px' }">
          <li v-if="selectTag.path !== '/index'" @click="closeSelectedTag(selectTag)">{{$t('close')}}</li>
          <li @click="closeAllTags">{{$t('closeAll')}}</li>
        </ul> 
        </div> -->
    <!-- 展示tab签 -->
    <div class="tabs-wrt">
      <ul class="contextmenu" v-show="visible" :style="{left:left+'px',top:'20px' }">
        <li v-if="selectTag.path !== '/index'" @click="closeSelectedTag(selectTag)">{{$t('close')}}</li>
        <li @click="closeAllTags">{{$t('closeAll')}}</li>
      </ul> 
      <div class="content-tabs">
        <el-tabs
          v-if="showTabs"
          ref="topTabs"
          v-model="editableTabsValue"
          type="card"
          @tab-click="tabClick"
          @tab-remove="removeTab"
          @contextmenu.prevent.native="openMenu($event)"
        >
          <el-tab-pane
            v-for="item in visitedViews"
            :key="item.path"
            :name="item.path"
            :closable="item.name !== 'index'"
          >
            <span slot="label">
              <!-- <span v-if="showFavoriteIcon(item)">
                <i
                  v-if="isFavorited(item)"
                  class="tab-icon el-icon-star-on collected"
                  alt="收藏图标"
                  @click.prevent.stop="favoriteIconClick(item, false)"
                />
                <i
                  v-else
                  class="tab-icon el-icon-star-on"
                  alt="收藏图标"
                  @click.prevent.stop="favoriteIconClick(item, true)"
                />
              </span> -->
              {{ $t(item.tagsName?item.tagsName:item.name) }}
              <!-- <img
                class="tab-icon tab-refresh-icon"
                src="@/assets/icon/refresh.svg"
                alt="刷新图标"
                @click="refresh(item.name)"
              > -->
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="net-monitor-wrap" :class="{'net-monitor-wran': responseNetTime>5000}" v-if="responseNetTime">
          <span class="icon"></span>
          <div id="net_monitor_div2">{{ responseNetTime }}ms</div>
        </div>
      </div>
    </div>
    <!-- 主内容 -->
    <keep-alive :include="cachedViews">
      <router-view class="main-container" v-if="routerFlag && this.$route.name != 'smartQuery' && this.$route.name != 'historyQuery'" ref='_contentView'/>
    </keep-alive>

    <keep-alive>
      <router-view  class="main-container" v-if="routerFlag && ['smartQuery', 'historyQuery'].includes(this.$route.name)" :key="this.$route.fullPath" ref='_contentView'/>
    </keep-alive>
  </el-main>
</template>

<script>
import { NetMonitor } from '@/assets/js/net-monitor';
import API from '@/api';
import { userInfo } from "@/global.js";
export default {
  props: ['menuLinkList'],
  watch: {
    $route () {
      this.addTags()
    },//地址栏变化了就触发这个添加方法
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  data () {
    return {
      viewWidth: 100,
      left: 0,
      visible: false,
      selectTag: {},
      editableTabsValue:'1',
      favoriteOn: require('@/assets/icon/favoriteOn.svg'),
      favoriteOff: require('@/assets/icon/favoriteOff.svg'),
      routerFlag: true,
      responseNetTime: null
    }
  },
  computed: {
    visitedViews () {
      return this.$store.state.appStore.visitedViews
    },
    cachedViews () {
      return this.$store.state.appStore.cachedViews
    },
    showTabs() {
      return (
        this.$route.path !== '/'
      )
    },
    // 已收藏的菜单
    collectMenus() {
      return this.$store.state.appStore.collectMenus
    }
  },
  methods: {
    openMenu (e) { // 右键打开tags菜单
      let item = {}
      if (e.srcElement.parentNode.id) {
        let currentContextTabPath = e.srcElement.parentNode.id.split("-")[1];
        item = this.visitedViews.find(obj => obj.path === currentContextTabPath);
        this.selectTag = item
      }

      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.visible = true
    },
    closeMenu () { // 点击右键菜单以后关闭右键菜单
      this.visible = false
    },
    addTags () {
      const route = this.$route;//获取地址栏路由
      if(route.name=='index' || route.name=='unauthorized'){
        // 收起侧边栏
        this.$store.commit('COLLAPSE_ALL_SIDE', true)
        this.$store.commit('setCollapse', true)
      }else{
        // 展开侧边栏
        this.$store.commit('COLLAPSE_ALL_SIDE', false)
        if(!['suPackNew', 'guidedPack', 'vasWorkbench'].includes(route.name)){
          this.$store.commit('setCollapse', false)
        }
      }
      
      let isTabMenu = false
      this.editableTabsValue = route.path
      // 从左侧列表中获取tab，如果存在则新开tab页，并设置tab页名称
      let curMenu
      this.menuLinkList.some(menu => {
        if (menu.menuLink === route.path) {
          isTabMenu = true
          curMenu = menu
          return true;
        }
        if (menu.url === route.path) {
          isTabMenu = true
          curMenu = menu
          return true;
        }
      })

      if (isTabMenu) {
        this.$store.commit({
          type: 'addTags',
          route,
          curMenu
        })
      }

      this.processSubRoute();
      if (route.meta && route.meta.cache) {
        // 清除相关页面缓存信息
        this.removeRelatedPageCache();
        this.$store.commit({ type: "changeKeepAlive", name: route.name, flag: "add", fullPath: route.fullPath });
      }
      return false
    },
    // 处理子路由
    processSubRoute () {
      let route = this.$route;//获取地址栏路由
      if (route.meta && route.meta.parentPaths) {
        if (this.visitedViews) {
          this.visitedViews.some(item => {
            if (route.meta.parentPaths.indexOf(item.path) != -1) {
              item.path = route.path
              return true;
            }
          })
        }

        if (this.menuLinkList) {
          this.menuLinkList.some(menu => {
            if (route.meta.parentPaths.indexOf(menu.menuLink) != -1) {
              menu.menuLink = route.path
              return true;
            }
            if (route.meta.parentPaths.indexOf(menu.url) != -1) {
              menu.url = route.path
              return true;
            }
          })
        }
      }
    },
    closeAllTags () {
      // 关闭全部tags的操作
      this.$store.dispatch('closeALLTags').then(() => {
        this.$router.push({ path: '/index' }) //this.$router.push('/Navview')
      })
      this.restoreAllRoute()
      this.$store.commit({ type: "changeKeepAlive", name: [], flag: "clear" });
    },
    // 恢复所有路由
    restoreAllRoute () {
      if (this.menuLinkList) {
        this.menuLinkList.forEach(menu => {
          if(menu.menuLink) {
            menu.menuLink = menu.baseUrl;
          }
          if(menu.url) {
            menu.url = menu.baseUrl;
          }
        })
      }
    },
    changeViewWidth (viewWidth) {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.$refs.wrap.firstElementChild.style.width = viewWidth + 'px'
      }
    },
    isActive (route) {   //  当前地址栏路径是否与渲染的路径相同 样式匹配
      // 如果未在menuLinkList中，则认为tab页内跳转
      if(route.path === this.$route.path) {
        return true
      }
      if (this.$route.meta && this.$route.meta.parentPaths) {
        if (this.$route.meta.parentPaths.indexOf(route.path) != -1) {
          return true;
        }
      }
      return false
    },
    closeSelectedTag (view) {
      this.$store.dispatch("closeTags", view).then((views) => {
        // 此时的views是指的被删除后的visitedViews数组中存在的元素
        this.restoreSingleRoute()
        try {
          this.$store.commit({ type: "changeKeepAlive", name: view.name, flag: "remove", fullPath: view.path })
        } catch (e) {
          console.error(e);
        }
        if (this.isActive(view)) {  // 关闭的如果是自己就打开别的,否则不做操作
          let latestView
          if (this.visitedViews[views.index]) {   // 如果被关闭标签的后一个存在 则展示
            latestView = this.visitedViews[views.index]
          } else if (this.visitedViews[views.index - 1]) {   // 否则展示被关闭的前一个(前一个永远存在)
            latestView = this.visitedViews[views.index - 1]
          }
          if (latestView) {
            this.$router.push({ path: latestView.path })   // 如果数组不为空则让选中的标签为紧邻关闭标签的那一个
          } else {
            this.$router.push({ path: '/index' }); // 如果为空则页面跳转到首页 this.$router.push({path: '/Navview'});
          }
        }
      })
    },
    // 恢复单个路由
    restoreSingleRoute () {
      let route = this.$route;//获取地址栏路由
      if (route.meta && route.meta.parentPaths) {
        if (this.menuLinkList) {
          this.menuLinkList.some(menu => {
            if (menu.menuLink === route.path) {
              menu.menuLink = menu.baseUrl;
              return true;
            }
            if (menu.url === route.path) {
              menu.url = menu.baseUrl;
              return true;
            }
          })
        }
      }
    },
    // 清除相关页面缓存信息
    removeRelatedPageCache () {
      let route = this.$route;//获取地址栏路由
      if (route.meta && route.meta.relatedPageNames) {
        route.meta.relatedPageNames.forEach(item => {
          this.$store.commit({ type: "changeKeepAlive", name: item, flag: "remove" })
        })
      }
    },
    tabClick(e) {
      // 读取store中路由参数
      const item = this.visitedViews[e.index]
      if(item && item.curMenuInfo) {
        this.$store.commit('SET_TOP_INDEX', item.curMenuInfo.topIndex)
      } else {
        this.$store.commit('SET_TOP_INDEX', -1)
      }
      if(item.name === 'index'){
        this.$store.commit('SET_MENU_ROUTER_INDEX',true)
      }
      
      this.$router
        .push({ path: item.path, params: item.params, query: item.query })
        .catch((err) => err)

    },
    removeTab(e) {
      let item = this.visitedViews.find(obj => obj.path === e);
      this.closeSelectedTag(item)
    },
    showFavoriteIcon(item) {
      return item.name !== 'index'
    },
    isFavorited(menuInfo) {
      return this.collectMenus.find(menu => menu.url === menuInfo.path)
    },
    // 切换菜单选中状态
    async favoriteIconClick(item, flag) {
      const index = this.collectMenus.findIndex(menu => menu.id === item.curMenuInfo.id)
      const params = item.curMenuInfo
      if(index !== -1) {
        const code = item.curMenuInfo && item.curMenuInfo.code
        const result = await API.cancelFavoriteMenu({'code':code})
        if(result.data && result.data.resultCode == 1){
          this.collectMenus.splice(index, 1)
          this.handleConfrim(flag)
        }else{
          this.$message.error(this.$t(res.data.resultCode));
        }
      } else {
        if(this.collectMenus.length >= 10){
          return this.$notify.warning({
            title: this.$t('tips'),
            message: this.$t('quickEntranceMax10')
          })
        }
        const res = await API.addFavoriteMenu(params)
        if(res.data && res.data.resultCode == 1){
          this.collectMenus.push(item.curMenuInfo)
          this.handleConfrim(flag)
        }else{
          this.$message.error(this.$t(res.data.resultCode));
        }
      }
    },
    // 存入store
    async handleConfrim(addFlag) {
      try {
        this.$notify.success({
          title: this.$t('success'),
          message: addFlag ? this.$t('quickEntranceAddSuccessed') : this.$t('quickEntranceDeleteSuccessed')
        })
        console.log(this.collectMenus,'this.collectMenus')
        this.$store.commit('SET_COLLECT_MENUS', this.collectMenus)
      } catch (error) {
        console.log('出现异常', error)
      }
    },
    refresh() {
      this.routerFlag = false
      setTimeout(() => {
        this.routerFlag = true
      }, 500)
    },
    handleResponseNetTimeChange(data) {
      this.responseNetTime = window.responseNetTime
    }
  },
  mounted () {
    // 获取刷新页面以后保存的tags
    let tags = JSON.parse(window.localStorage.getItem('tags'))
    //  获取之后删除session,避免关闭tags后的错误
    window.localStorage.removeItem('tags')
    if (tags) {
      this.$store.state.appStore.visitedViews = tags
    }
    this.addTags()
    let warehouseNo = userInfo.warehouseNo
    let host = window.location.host.replaceAll('.', '_')
    // 网络监控
    // 参数url 为该项目所属域名，因为访问其他域名会有跨域问题，需要在nginx上做反向代理实现访问
    // 参数time，为定时访问频率，默认10s， 尽量在[5, 20]区间
    let monitor = new NetMonitor(`/netDelayApi/${host}/${warehouseNo}`, 10000);
    monitor.timing();
    window.addEventListener('responseNetTime', this.handleResponseNetTimeChange);
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  a {
    text-decoration: none;
  }
  .main-container {
    height: 100%;
    padding: 16px !important;
  }
  .tags-view-container {
    height: 44px;
    width: 100%;
    border-radius: 8px;
    background: #fff;
    margin-bottom:16px;
    padding-top: 4px;
    // overflow: hidden;
    white-space:nowrap;
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        line-height: 44px;
        height: 44px;
        color: #495060;
        background: #fff;
        font-size: 14px;
        box-sizing: border-box;
        padding: 0 20px;
        border-radius: 5px 5px 0 0;
        font-weight: 500;
        &:hover{
          /* z-index:4;
          background: #f5f5f6;
          border-radius: 12px 12px 0 0;
          -webkit-box-shadow: 12px 12px 0 0 #f5f5f6, -12px 12px 0 0 #f5f5f6;
          box-shadow: 12px 12px 0 0 #f5f5f6, -12px 12px 0 0 #f5f5f6;
          &::before {
            content: "";
            position: absolute;
            left: -12px;
            bottom: 0px;
            width: 12px;
            height: 44px;
            background: #ffffff;
            border-radius: 0 0 12px 0;
          }
          &::after {
            content: "";
              position: absolute;
              right: -12px;
              bottom: 0;
              width: 12px;
              height: 44px;
              background: #ffffff;
              border-radius: 0 0 0 12px;
          } */
        }
        &:first-of-type {
          margin-left: 15px;
        }
        &:last-of-type {
          margin-right: 15px;
        }
        &.active {
          z-index:4;
          font-weight: 600;
          color: #3C6EF0;
          background: #f5f5f6;
          border-radius: 12px 12px 0 0;
          -webkit-box-shadow: 12px 12px 0 0 #f5f5f6, -12px 12px 0 0 #f5f5f6;
          box-shadow: 12px 12px 0 0 #f5f5f6, -12px 12px 0 0 #f5f5f6;
          &::before {
            content: "";
            position: absolute;
            left: -12px;
            bottom: 0px;
            width: 12px;
            height: 44px;
            background: #ffffff;
            border-radius: 0 0 12px 0;
          }
          &::after {
            content: "";
              position: absolute;
              right: -12px;
              bottom: 0;
              width: 12px;
              height: 44px;
              background: #ffffff;
              border-radius: 0 0 0 12px;
          }
        }
      }
    .is-vertical {
      display: none;
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 100;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
  .tabs-wrt{
    // border-bottom: 16px solid #f5f5f6;
    padding-top: 5px;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 50;
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 100;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
  .content-tabs {
  display: flex;
  align-items: center;  
  justify-content: space-between;
  background-color: #fff;
  ::v-deep .el-tabs {
    margin-left: 20px;
    width: calc(100% - 135px);
    .el-tabs__header {
      border-bottom: 0;
      margin-bottom: 0;
      user-select: none;
      .el-tabs__nav-wrap {
        margin-bottom: 0;
        &.is-scrollable {
          padding: 0 38px;
        }
        .el-tabs__nav-next,
        .el-tabs__nav-prev {
          background: #fff;
          line-height: 30px;
          top: 5px;
          bottom: 5px;
          width: 30px;
          text-align: center;
          border-radius: 5px;
        }
      }
    }
    .el-tabs__nav {
      border: none;
    }
    .el-tabs__item:focus.is-active.is-focus:not(:active) {
      box-shadow: none;
    }
    .el-tabs__item {
      background-color: #fff;
      margin: 0;
      border: none;
      border-radius: 5px 5px 0 0;
      font-weight: normal;
      // &:hover {
      //   color: #3C6EF0;
      // }
      .el-icon-close {

        font-weight: 700;
        font-size: 13px;
      }
      /* &.is-active {
        background-color: #fff;
        &::before {
          content: "";
          display: inline-block;
          width: calc(100% - 75px);
          height: 2px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          background-color: #FFF;
        }
      } */
      &.is-active {
          z-index:4;
          font-weight: 600;
          color: #3C6EF0;
          background: #f5f5f6;
          border-radius: 12px 12px 0 0;
          -webkit-box-shadow: 12px 12px 0 0 #f5f5f6, -12px 12px 0 0 #f5f5f6;
          box-shadow: 12px 12px 0 0 #f5f5f6, -12px 12px 0 0 #f5f5f6;
          &::before {
            content: "";
            position: absolute;
            left: -12px;
            bottom: 0px;
            width: 12px;
            height: 44px;
            background: #ffffff;
            border-radius: 0 0 12px 0;
          }
          &::after {
            content: "";
              position: absolute;
              right: -12px;
              bottom: 0;
              width: 12px;
              height: 44px;
              background: #ffffff;
              border-radius: 0 0 0 12px;
          }
        }
      /* &::after {
        content: "";
        position: absolute;
        display: inline-block;
        width: 1px;
        height: 18px;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        background-color: #ddd;
      } */
      &:last-child {
        padding-right: 20px;
        // &::after{
        //   width: 0;
        // }
      }
    }
  }
  .tab-icon {
    margin-top: -4px;
    vertical-align: middle;
    font-size: 18px;
    color: #D2D2D2;
  }
  .collected {
    color: #FECB52;
  }
  .tab-refresh-icon {
    padding-left: 4px;
    margin-right: -4px;
  }
  .net-monitor-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 88px;
    margin-right: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: normal;
    color: rgba(82,87,101,1);
    width: 80px;
    height: 24px;
    background: rgba(186,190,199,0.4);
    border-radius: 20px;
    .icon{
      width: 16px;
      height: 16px;
      background-image: url('../../assets/images//new-menu/network.png');
      margin-right: 7px;
      background-repeat: no-repeat;
      background-size: 16px
    }
    #net_monitor_div2{
      color: rgba(82,87,101,1);
    }
  }
  .net-monitor-wran{
    background: rgba(252,55,55,0.1);
    .icon{
      width: 16px;
      height: 16px;
      background-image: url('../../assets/images//new-menu/network-warn.png');
      margin-right: 7px;
      background-repeat: no-repeat;
      background-size: 16px
    }
    #net_monitor_div2{
      color: rgba(252,55,55,1);
    }
  }
}
</style>
